import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { serviceData } from "../../../utils/data";

const Services = () => {
  return (
    <section className="main-section py-5">
      {/* This Section showcases our services */}
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={7}>
            <motion.div className="section-header text-center mb-5"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h3 className="text-primary">Our Services</h3>
              <p className="text-muted section-subtext">Experience the best crypto services with our platform</p>
            </motion.div>
          </Col>
        </Row>
        {/* Section showcasing our services  */}
        <Row className="g-4 justify-content-center service-cards-container">
          {serviceData.map((service, index) => (
            <Col key={index} lg={5} className="service-col">
              <motion.div className="service-card p-4 position-relative rounded-4 overflow-hidden"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10, transition: { duration: 0.2 } }}
              >
                <div className="service-icon rounded-pill d-flex align-items-center justify-content-center mb-3">
                  {service.icon}
                  <div className="icon-glow"></div>
                </div>
                <h3 className="service-title fs-5 fw-semibold mb-2 text-uppercase">{service.title}</h3>
                <p className="service-description small">{service.description}</p>
                <div className="service-card-bg"></div>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Services;
